import React from 'react';
import { PADMORA_USA_REGISTERED } from "@/lib/constants";
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-background py-12 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto text-center">
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold mb-4 text-slate-800">Padmora</h3>
            <p className="text-slate-600 text-sm">
              {PADMORA_USA_REGISTERED} · AI-powered commodity trading
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-slate-800">Trading</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/platform" className="hover:text-blue-600 transition-colors">AI Platform</Link></li>
              <li><Link to="/trading" className="hover:text-blue-600 transition-colors">LC-Backed Deals</Link></li>
              <li><Link to="/trading/amsul-usa" className="hover:text-blue-600 transition-colors">Ammonium Sulphate → USA</Link></li>
              <li><Link to="/trading/palm-products" className="hover:text-blue-600 transition-colors">Palm Products → World</Link></li>
              <li><Link to="/trading/base-oil" className="hover:text-blue-600 transition-colors">Base Oil → Africa</Link></li>
              <li><Link to="/consumer-pack" className="hover:text-blue-600 transition-colors">Consumer Pack → Caribbean</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-slate-800">Company</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/about" className="hover:text-blue-600 transition-colors">About</Link></li>
              <li><Link to="/store" className="hover:text-blue-600 transition-colors">Store</Link></li>
              <li><Link to="/compliance" className="hover:text-blue-600 transition-colors">Compliance</Link></li>
              <li><Link to="/lc-policy" className="hover:text-blue-600 transition-colors">LC Policy</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-slate-800">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/privacy" className="hover:text-blue-600 transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-blue-600 transition-colors">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-200 mt-8 pt-8 text-center text-sm text-slate-500">
          <p>&copy; 2026 Padmora. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
